const EducationData = [
    {
        id: 1,
        title: "Bachelor of Science in Computer Science",
        company: "Webster University in Tashkent",
        yearsActive: "Aug. 2026 – Present",
        information: [
            "Pursuing a degree in Computer Science in Tashkent, Uzbekistan."
        ],
    },
    {
        id: 2,
        title: "Software Developer",
        company: "IT Park Termez",
        yearsActive: "November 2025 – Present",
        information: [
            "Expanded into full-stack development, specializing in PHP, Python, and the Next.js framework.",
            "Engineered automated solutions and Telegram bots to solve local business challenges in Surxondaryo.",
            "Participated in regional tech initiatives to build scalable digital infrastructure for the community.",
        ],
    },
    {
        id: 3,
        title: "Full Stack Web Development Bootcamp",
        company: "Joylinks Academy",
        yearsActive: "Nov. 2025 – Jun. 2026",
        information: [
            "Completed an intensive bootcamp on full-stack web development at Alpomish str, Termiz.",
        ],
    },
    {
        id: 4,
        title: "Founder & Product Strategist",
        company: "Startup Incubation",
        yearsActive: "March 2025 – Present",
        information: [
            "Completing a specialized program focused on the lifecycle of a tech startup, from initial ideation to MVP launch.",
            "Mastering product management strategies, including user research, business modeling, and scaling digital platforms.",
            "Developing leadership skills by managing end-to-end development workflows and aligning technical goals with business needs.",
        ],
    },
    {
        id: 5,
        title: "Full Stack Trainee",
        company: "Billion School",
        yearsActive: "September 2024 – February 2025",
        information: [
            "Mastered the foundations of web development, focusing on HTML, CSS, and modern JavaScript.",
            "Built and deployed responsive user interfaces for a variety of academic and certification projects.",
            "Collaborated with senior instructors to refine code quality and implement industry-standard UI patterns.",
        ],
    }
];

export default EducationData;
